import React from 'react';
import { Block } from "@randajan/jet-react/dom/block";
import page from "@randajan/jet-react/base/page";
import { Link } from "@randajan/jet-react/dom/link";

import "./ShopLink.scss";



export const ShopLink = (props)=>{
    const {id, name, webPath} = props;

    return (
        <Link className="ShopLink" to={`/kupsi/${webPath}`}>
            {name}
        </Link>
    )
}

